import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const auth = localStorage.getItem("auth");
  return auth ? <>{children}</> : <Navigate to="/" replace />;
};

export default PrivateRoute;
